export type StringMatch = {
  str: string;
  isMatch: boolean;
};

/**
 * Splits a string into parts that contain the search words and parts that don't
 * @param str - the string to split
 * @param searchWords - the words to search for
 * @returns An array of StringMatch objects ({ str: string, isMatch: boolean })
 */
export const convertStringToMatchedWords = (str: string, searchWords: string[]): StringMatch[] => {
  const words = str.split(' ');
  const stringParts = words.flatMap((word, index) => {
    const searchWordWithMatch = searchWords.find((searchWord) => word.toLowerCase().includes(searchWord.toLowerCase()));
    const isLastWord = index === words.length - 1;

    if (!searchWordWithMatch)
      return {
        str: isLastWord ? word : word + ' ',
        isMatch: false,
      };

    const matchIndex = searchWordWithMatch ? word.toLowerCase().indexOf(searchWordWithMatch.toLowerCase()) : -1;
    const matchEndIndex = matchIndex + searchWordWithMatch.length;
    return [
      { str: word.substring(0, matchIndex), isMatch: false },
      { str: word.substring(matchIndex, matchEndIndex), isMatch: true },
      { str: word.substring(matchEndIndex) + (isLastWord ? '' : ' '), isMatch: false },
    ].filter(({ str }) => !!str);
  });

  const reducedStringParts = stringParts.reduce<StringMatch[]>((acc, curr) => {
    const lastPartMatch = acc.length ? acc[acc.length - 1] : false;
    if (lastPartMatch === curr.isMatch && !!acc[acc.length - 1]) {
      acc[acc.length - 1]!.str += curr.str;
      return acc;
    }
    acc.push(curr);
    return acc;
  }, []);

  return reducedStringParts;
};
